import React, { useState, useEffect } from "react";
import TabContext from "@mui/lab/TabContext";
import Div from "@jumbo/shared/Div";
import List from "@mui/material/List";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import JumboCardQuick from "@jumbo/components/JumboCardQuick";
import styled from "@emotion/styled";
import Span from "@jumbo/shared/Span";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { useProfileContext } from "../../../parent/Profile/context";
import { useTranslation } from "react-i18next";
import PaymentOutlinedIcon from "@mui/icons-material/PaymentOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import VpnKeyOutlinedIcon from "@mui/icons-material/VpnKeyOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import AboutForm from "./CardForm2";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton"; // Stripe form
import CreditCardOffIcon from "@mui/icons-material/CreditCardOff";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import PaymentIcon from "@mui/icons-material/Payment";

const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: 24,
  height: 48,
  width: 48,
  borderRadius: "50%",
  minWidth: 42,
  marginRight: 16,
  padding: theme.spacing(1),
  alignItems: "center",
  justifyContent: "center",
  border: `solid 1px ${theme.palette.divider}`,
}));

const CardInfo = () => {
  const [openDialog, setOpenDialog] = React.useState(false);
  const { globalState, setGlobalState } = useProfileContext();
  const { t } = useTranslation();
  const [cardInfo, setCardInfo] = useState(null);
  const [paymentError, setPaymentError] = useState("");

  useEffect(() => {
    if (globalState.profile) {
      console.log(
        "-----CardInfo------------------>",
        globalState.profile?.cardInfo,
      );
      console.log(
        "-----stripeLastPayment------------------>",
        globalState.profile?.stripeLastPayment?.failure?.message,
      );
      setCardInfo(globalState.profile.cardInfo);
      setPaymentError(
        globalState.profile?.stripeLastPayment?.failure?.message || "",
      );
    }
  }, [globalState]);

  useEffect(() => {
    if (globalState.refreshList) {
      //console.log("🔄 Refreshing card info...");
      setCardInfo(globalState.profile.cardInfo);
      setGlobalState({ ...globalState, refreshList: false });
    }
  }, [globalState.refreshList]);

  const handleEditClick = () => setOpenDialog(true);

  const getCardBrand = (brand) => {
    switch (brand) {
      case "visa":
        return {
          label: "Visa",
          icon: <img src="/images/icons/visa.png" alt="Visa" width={32} />,
        };
      case "mastercard":
        return {
          label: "Mastercard",
          icon: (
            <img src="/images/icons/master.png" alt="Mastercard" width={32} />
          ),
        };
      case "american_express":
        return {
          label: "American Express",
          icon: (
            <img
              src="/images/icons/american.png"
              alt="American Express"
              width={32}
            />
          ),
        };
      case "union_pay":
        return {
          label: "UnionPay",
          icon: (
            <img src="/images/icons/unionpay.png" alt="UnionPay" width={32} />
          ),
        };
      case "discover":
        return {
          label: "Discover",
          icon: (
            <img src="/images/icons/discover.png" alt="Discover" width={32} />
          ),
        };
      case "diners_club":
        return {
          label: "Diners Club",
          icon: (
            <img src="/images/icons/diners.png" alt="Diners Club" width={32} />
          ),
        };
      case "jcb":
        return {
          label: "JCB",
          icon: <img src="/images/icons/jcb.png" alt="JCB" width={32} />,
        };
      default:
        return {
          label: brand ? brand.replace(/_/g, " ") : "Unknown",
          icon: <CreditCardIcon />,
        };
    }
  };

  const getCardBrandOld = (brand) => {
    switch (brand) {
      case "visa":
        return { label: "Visa", icon: <CreditCardIcon /> };
      case "mastercard":
        return { label: "Mastercard", icon: <PaymentIcon /> };
      case "american_express":
        return { label: "American Express", icon: <CreditCardIcon /> };
      default:
        return {
          label: brand ? brand.replace(/_/g, " ") : "Unknown",
          icon: <CreditCardIcon />,
        };
    }
  };

  return (
    <JumboCardQuick
      title={
        <Typography variant={"h4"} mb={0}>
          {t("parent.title.cardDetails")}
          <Span sx={{ color: "text.secondary", fontSize: 13 }}>
            <EditOutlinedIcon
              onClick={handleEditClick}
              sx={{ fontSize: 13, ml: 1 }}
            />
          </Span>
        </Typography>
      }
      headerSx={{ borderBottom: 1, borderColor: "divider" }}
    >
      {cardInfo ? (
        <List
          disablePadding
          sx={{
            display: "flex",
            flexWrap: "wrap",
            margin: (theme) => theme.spacing(0, -2),
            mb: 2,
          }}
        >
          <ListItem sx={{ width: { xs: "100%", sm: "50%", xl: "100%" } }}>
            <StyledListItemIcon>
              <PaymentOutlinedIcon fontSize="inherit" />
            </StyledListItemIcon>
            <ListItemText
              primary={
                <Typography
                  fontSize="12px"
                  variant="h6"
                  color="text.secondary"
                  mb={0.5}
                >
                  {t("parent.title.cardNo")}
                </Typography>
              }
              secondary={
                <Typography variant="body1" color="text.primary">
                  {`**** **** **** ${cardInfo?.last4}`}
                </Typography>
              }
            />
          </ListItem>

          <ListItem sx={{ width: { xs: "100%", sm: "50%", xl: "33.33%" } }}>
            <StyledListItemIcon>
              <CalendarTodayOutlinedIcon fontSize="inherit" />
            </StyledListItemIcon>
            <ListItemText
              primary={
                <Typography
                  fontSize="12px"
                  variant="h6"
                  color="text.secondary"
                  mb={0.5}
                >
                  {t("parent.title.cardExpiry")}
                </Typography>
              }
              secondary={
                <Typography variant="body1" color="text.primary">
                  {cardInfo?.exp_month && cardInfo?.exp_year
                    ? `${String(cardInfo.exp_month).padStart(2, "0")}/${String(cardInfo.exp_year).slice(-2)}`
                    : "--/--"}
                </Typography>
              }
            />
          </ListItem>

          <ListItem sx={{ width: { xs: "100%", sm: "50%", xl: "33.33%" } }}>
            <StyledListItemIcon>
              {getCardBrand(cardInfo?.display_brand).icon}
            </StyledListItemIcon>
            <ListItemText
              primary={
                <Typography
                  fontSize="12px"
                  variant="h6"
                  color="text.secondary"
                  mb={0.5}
                >
                  Card Type
                </Typography>
              }
              secondary={
                <Typography variant="body1" color="text.primary">
                  {getCardBrand(cardInfo?.display_brand).label}
                </Typography>
              }
            />
          </ListItem>

          {paymentError && (
            <ListItem sx={{ width: { xs: "100%", sm: "50%", xl: "100%" } }}>
              <StyledListItemIcon
                sx={{
                  color: "error.main", // icon red
                  borderColor: "error.main", // make border red too
                }}
              >
                <CreditCardOffIcon fontSize="inherit" sx={{ color: "red" }} />
              </StyledListItemIcon>

              <ListItemText
                secondary={
                  <Typography variant="body1" sx={{ color: "error.main" }}>
                    {paymentError}
                  </Typography>
                }
              />
            </ListItem>
          )}
        </List>
      ) : (
        <List
          disablePadding
          sx={{
            display: "flex",
            flexWrap: "wrap",
            margin: (theme) => theme.spacing(0, -2),
            mb: 2,
          }}
        >
          <ListItem sx={{ width: { xs: "100%", sm: "50%", xl: "100%" } }}>
            <StyledListItemIcon>
              <CreditCardOffIcon fontSize="inherit" />
            </StyledListItemIcon>
            <ListItemText
              primary={
                <Typography
                  fontSize="12px"
                  variant="h6"
                  color="text.secondary"
                  mb={0.5}
                >
                  No Card Details Added
                </Typography>
              }
            />
          </ListItem>
        </List>
      )}

      {/* Stripe Dialog */}
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        maxWidth="lg" // increase size: 'sm', 'md', 'lg', 'xl'
        fullWidth
      >
        <DialogTitle>
          {t("parent.title.updateDetails")}
          <IconButton
            aria-label="close"
            onClick={() => setOpenDialog(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <AboutForm hide={setOpenDialog} />
        </DialogContent>
      </Dialog>
    </JumboCardQuick>
  );
};

export default CardInfo;
